import type { ComposerTranslation } from 'vue-i18n'

/** 与接口 `/logmanage/admin-operation/list` 行数据对齐；`template_id`（或 `opt_type`）为 1–68 时走 i18n */
export type AdminOperationRowLike = {
  operation?: string
  template_id?: string | number
  variables?: string
  opt_type?: string | number
  opt_data?: string | Record<string, unknown>
}

function parseOptData(raw: unknown): Record<string, string | number> {
  if (raw == null || raw === '') return {}
  try {
    const obj = typeof raw === 'string' ? (JSON.parse(raw) as unknown) : raw
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
      const out: Record<string, string | number> = {}
      for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
        if (v == null) continue
        if (typeof v === 'string' || typeof v === 'number') {
          out[k] = v
        } else if (typeof v === 'boolean') {
          out[k] = v ? 1 : 0
        } else {
          out[k] = JSON.stringify(v)
        }
      }
      return out
    }
  } catch {
    // ignore
  }
  return {}
}

/** 解析为 1–68 的模板编号；否则返回 null（沿用接口 operation 原文） */
export function resolveAdminOperationOptType(row: AdminOperationRowLike): string | null {
  const raw = row.template_id ?? row.opt_type ?? row.operation
  if (raw === null || raw === undefined) return null
  const s = String(raw).trim()
  if (!/^\d+$/.test(s)) return null
  const n = Number(s)
  if (!Number.isFinite(n) || n < 1 || n > 68) return null
  return s
}

/**
 * 列表/概览区展示的操作说明：有 `opt_type` 且存在对应文案键时用 `t` + `opt_data` 插值；否则回退 `operation`。
 */
export function adminOperationDisplayText(
  t: ComposerTranslation,
  te: (key: string) => boolean,
  row: AdminOperationRowLike,
): string {
  const typeKey = resolveAdminOperationOptType(row)
  const params = parseOptData(row.variables ?? row.opt_data)
  if (typeKey) {
    const i18nKey = `noticeManage.adminOperationActions.${typeKey}`
    if (te(i18nKey)) {
      try {
        return String(t(i18nKey, params as Record<string, unknown>))
      } catch {
        return String(t(i18nKey))
      }
    }
  }
  const op = row.operation
  if (op != null && String(op).trim() !== '') return String(op)
  return '--'
}
